module.exports = __webpack_public_path__ + "static/media/file_mau_gui_tin_nhan_zalo.0f00d67e.xlsx";